import React from 'react';
import { defaultTemplate } from 'core/hoc';
import { DatePicker, NotifyOutsideClick, SliderCheckBox, Loader } from 'core/components';
import moment from 'moment';

const ExportToCSVByDateTemplate = ({
	t,
	exportToCSVByDateViewStore: {
		openDatePickerPopup,
		isExportDatePickerOpen,
		exportForm,
		format,
		exportDataToCSV,
		closePopup,
		rootStore,
		setIsValidDate,
		isValidDate,
		loading,
	},
}) => {
	if (loading) return <Loader />;
	return (
		<NotifyOutsideClick action={closePopup}>
			<div className="header__profile">
				<div onClick={openDatePickerPopup}>
					<span>{t('EXPORTTOXLS.TITLE')}</span>

					<i className="fa fa-angle-down spc--left--sml" />
				</div>
				<div className="header__profile--csv">
					<div className={'header__profile--dropdown' + (isExportDatePickerOpen ? ' active' : '')}>
						<ul>
							<SliderCheckBox field={exportForm.$('useShipByDate')} />
							{!exportForm.$('useShipByDate').value ? (
								<React.Fragment>
									<div className="spc--bottom--sml">
										<DatePicker
											field={exportForm.$('startDate')}
											maxDate={moment(exportForm.$('endDate').value, format).toDate()}
											format={format}
											rootStore={rootStore}
											setIsValidDate={setIsValidDate}
											showValidation={false}
										/>
									</div>
									<div className="spc--bottom--sml">
										<DatePicker
											field={exportForm.$('endDate')}
											minDate={moment(exportForm.$('startDate').value, format).toDate()}
											format={format}
											rootStore={rootStore}
											setIsValidDate={setIsValidDate}
											showValidation={false}
										/>
									</div>
								</React.Fragment>
							) : (
								<React.Fragment>
									<div className="spc--bottom--sml">
										<DatePicker
											field={exportForm.$('shipByStartDate')}
											maxDate={moment(exportForm.$('shipByEndDate').value, format).toDate()}
											format={format}
											rootStore={rootStore}
											setIsValidDate={setIsValidDate}
											showValidation={false}
										/>
									</div>
									<div className="spc--bottom--sml">
										<DatePicker
											field={exportForm.$('shipByEndDate')}
											minDate={moment(exportForm.$('shipByStartDate').value, format).toDate()}
											format={format}
											rootStore={rootStore}
											setIsValidDate={setIsValidDate}
											showValidation={false}
										/>
									</div>
								</React.Fragment>
							)}

							<button
								type="button"
								className="btn btn--med btn--secondary push"
								onClick={exportDataToCSV}
								disabled={
									(!exportForm.$('useShipByDate').value &&
										(exportForm.$('startDate').value === '' || exportForm.$('endDate').value === '' || !isValidDate)) ||
									(exportForm.$('useShipByDate').value &&
										(exportForm.$('shipByStartDate').value === '' ||
											exportForm.$('shipByEndDate').value === '' ||
											!isValidDate))
								}
							>
								{t('CONFIRM')}
							</button>
						</ul>
					</div>
				</div>
			</div>
		</NotifyOutsideClick>
	);
};

export default defaultTemplate(ExportToCSVByDateTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/modules/order/pages/ExportToCSVByDateTemplate.jsx